export function getInstantResultsInitialState() {
    return {};
}
